module.exports = __webpack_public_path__ + "assets/img/产品页小图替换2.3bfa2062.jpg";